(() => {
  'use strict';
  const video = document.getElementById('hero-video');
  const toggle = document.getElementById('video-toggle');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let manuallyPaused = false;
  let loaded = false;
  let inView = false;
  function renderIcons() { window.lucide?.createIcons(); }
  function syncVideoButton() {
    const isPlaying = !video.paused;
    toggle.setAttribute('aria-label', isPlaying ? window.AzureV8Text.pause : window.AzureV8Text.play);
    toggle.title = toggle.getAttribute('aria-label');
    const icon = document.createElement('i');
    icon.dataset.lucide = isPlaying ? 'pause' : 'play';
    icon.setAttribute('aria-hidden', 'true');
    toggle.replaceChildren(icon);
    renderIcons();
  }
  async function playVideo() {
    if (!loaded) {
      const source = video.querySelector('source');
      source.src = source.dataset.src;
      video.load();
      loaded = true;
    }
    try { await video.play(); } catch { syncVideoButton(); }
  }
  toggle.addEventListener('click', () => {
    if (video.paused) { manuallyPaused = false; playVideo(); }
    else { manuallyPaused = true; video.pause(); }
  });
  video.addEventListener('play', syncVideoButton);
  video.addEventListener('pause', syncVideoButton);
  const observer = new IntersectionObserver(entries => {
    inView = entries[0].isIntersecting;
    if (!inView) video.pause();
    else if (!manuallyPaused && !reducedMotion.matches && !navigator.connection?.saveData && !document.hidden) playVideo();
  }, { threshold: 0.15 });
  observer.observe(video);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) video.pause();
    else if (inView && !manuallyPaused && !reducedMotion.matches && !navigator.connection?.saveData) playVideo();
  });
  reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) video.pause(); });
  renderIcons();
})();

(() => {
  const shuffle = items => {
    const shuffled = [...items];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };
  const handle = item => item.querySelector('[data-product-handle]')?.dataset.productHandle;
  function selectPieces(rail) {
    const pool = rail.querySelector('[data-rail-pool]');
    if (!pool) return;
    const candidates = [...pool.content.children];
    if (!candidates.length) return;
    let selection;
    const key = 'azure-v8-first-' + rail.dataset.collection;
    let previous = '';
    try { previous = localStorage.getItem(key) || ''; } catch { /* Storage is optional. */ }
    if (rail.dataset.curated === 'true' && window.AzureV9Select) {
      selection = window.AzureV9Select(candidates.map(node => ({
        handle: handle(node),
        family: node.dataset.editorialGroup,
        lead: node.dataset.editorialLead === 'true',
        node
      })), previous).map(item => item.node);
    } else if (rail.dataset.collection === 'dehua') {
      const groups = shuffle(['statue', 'vase', 'other'])
        .map(group => shuffle(candidates.filter(item => item.dataset.productGroup === group)))
        .filter(group => group.length);
      selection = [];
      while (selection.length < 12 && groups.some(group => group.length)) {
        for (const group of groups) {
          if (group.length && selection.length < 12) selection.push(group.shift());
        }
      }
    } else selection = shuffle(candidates).slice(0, 12);
    if (selection.length > 1 && handle(selection[0]) === previous) {
      [selection[0], selection[1]] = [selection[1], selection[0]];
    }
    try { localStorage.setItem(key, handle(selection[0])); } catch { /* Storage is optional. */ }
    rail.querySelector('.rail-track').replaceChildren(...selection.map(item => item.cloneNode(true)));
    rail.dataset.poolSize = String(candidates.length);
    rail.dataset.selection = 'per-visit';
  }
  for (const rail of document.querySelectorAll('.collection-rail')) {
    if (rail.dataset.initialized) continue;
    selectPieces(rail);
    const track = rail.querySelector('.rail-track');
    const controls = rail.querySelector('.rail-controls');
    if (!track || !controls || !track.children.length) continue;
    rail.dataset.initialized = 'true';
    const previous = controls.querySelector('[data-rail-prev]');
    const next = controls.querySelector('[data-rail-next]');
    const status = controls.querySelector('.rail-status');
    controls.hidden = false;
    let queued = false;
    const update = () => {
      queued = false;
      const box = track.getBoundingClientRect();
      const cards = [...track.children].map(el => el.getBoundingClientRect());
      const first = cards.findIndex(r => r.right > box.left + 3);
      const last = cards.findLastIndex(r => r.left < box.right - 3);
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollWidth - track.clientWidth - track.scrollLeft < 2;
      status.textContent = window.AzureV8Text.railStatus.replace('[start]', first + 1).replace('[end]', last + 1).replace('[total]', cards.length);
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    const move = direction => {
      const width = track.children[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = (width + gap) * Math.max(1, Math.floor((track.clientWidth + gap) / (width + gap)));
      track.scrollBy({left:direction * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') track.scrollTo({left:0});
      else if (event.key === 'End') track.scrollTo({left:track.scrollWidth});
      else move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    track.addEventListener('scroll', schedule, {passive:true});
    new ResizeObserver(schedule).observe(track);
    schedule();
  }
  window.lucide?.createIcons();
})();
